module.exports = __webpack_public_path__ + "img/FormTemplates.1f29d383.svg";